import React from "react";
import PropTypes from "prop-types";
import { Card, CardHeader } from "reactstrap";
import Details from "./proposal-details";
import TooltipButton from "../../../ui/tooltip-button";

const Proposal = ({ noProposal, proposals, selected, select, customSelect, addManual }) => {
  return (
    <div className="col-md-6 col-12">
      {noProposal ? (
        <Card className="h-100">
          <CardHeader className="d-flex align-items-center justify-content-between">
            <div className="empty-container">
              <h3>Propuestas de conciliación</h3>
              <div className="image-no-proposal">
                <span className="icono-info-alert" />
              </div>
              <h4 className="align-self-center">
                El algoritmo no ha encontrado partidas para conciliar
              </h4>
              <TooltipButton
                buttonClassName="create-manual-proposal-button mt-2"
                onClick={addManual}
                buttonText="Crear partida"
                tooltipText="Crear partida"
              />
            </div>
          </CardHeader>
        </Card>
      ) : (
        <Details
          proposals={proposals}
          selected={selected}
          select={select}
          customSelect={customSelect}
        />
      )}
    </div>
  );
};
Proposal.propTypes = {
  addManual: PropTypes.func,
  noProposal: PropTypes.bool,
  proposals: PropTypes.arrayOf(
    PropTypes.shape({
      origins: PropTypes.arrayOf(PropTypes.shape({})),
      rules: PropTypes.arrayOf(PropTypes.shape({})),
      tercero: PropTypes.string
    })
  ),
  selected: PropTypes.number,
  select: PropTypes.func,
  customSelect: PropTypes.func
};

Proposal.defaultProps = {
  noProposal: false,
  proposals: [],
  selected: 0,
  select: () => {},
  addManual: () => {},
  customSelect: () => {}
};
export default Proposal;
